module.exports = __webpack_public_path__ + "static/media/jayanSir.485913d1.png";